import { useEffect, useState } from 'react'

interface UseScrollToBottomButtonProps {
  threshold?: number // Khoảng cách từ bottom để hiển thị nút (px)
}

export const useScrollToBottomButton = ({ threshold = 300 }: UseScrollToBottomButtonProps = {}) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight

      // Hiển thị nút khi scroll lên trên và cách bottom một khoảng threshold
      const isNearBottom = scrollTop + windowHeight >= documentHeight - threshold
      setIsVisible(!isNearBottom) // Chỉ hiển thị khi scroll xuống ít nhất 100px
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll() // Kiểm tra ngay khi mount

    return () => window.removeEventListener('scroll', handleScroll)
  }, [threshold])

  const scrollToBottom = (behavior: ScrollBehavior = 'smooth') => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior,
    })
  }

  return {
    isVisible,
    scrollToBottom,
  }
}
